'use strict';

var FlightCabinAggregationFactory = function FlightCabinAggregationFactory(FlightThematicDataAggregationFactory) {
  function FlightCabinAggregation() {
    FlightThematicDataAggregationFactory.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'thematic-flight-chart-cabin');
    this.aggregationProperty = 'cabinCode';
  }
  FlightCabinAggregation.prototype = Object.create(FlightThematicDataAggregationFactory.prototype);
  FlightCabinAggregation.constructor = FlightCabinAggregation;
  return FlightCabinAggregation;
};
FlightCabinAggregationFactory.$inject = ['FlightThematicDataAggregationFactory'];
module.exports = FlightCabinAggregationFactory;